module.exports = __webpack_public_path__ + "static/media/mic_waveform_light.e9918741.svg";